import React, { useEffect, useState, useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import CreateLeaveRequestModal from "./modal/create_leave_request";
import { ApiService } from "../../../services/ApiService";
import { useAlert } from "react-alert";
import EditLeaveRequestModal from "./modal/edit_leave_request";
import { ConfirmTemplate } from "../../../components/confirm";
import RejectRequestModal from "./modal/reject";
import useModal from "../../../utils/useModal";
import Modal from "react-modal";
import { AuthContext } from "../../../Context/AuthContext";
import moment from "moment";
import { capitalize } from "../../../utils/capitalize";

import { holidaysMngtThunk } from "../../../store/actions/holidaymanagement/holiday.thunk";
import { useDispatch, useSelector } from "react-redux";
const helper = require("../../../utils/exportToExcel/helper");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const HolidayIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const [EditValue, setEditValue] = useState([]);
  const [rejectstate, SetRejectState] = useState("");
  const [rejectRequested, SetRejectRequested] = useState("");
  const [rejectApproved, SetRejectApproved] = useState("");
  const { modalIsOpen, openModal, closeModal } = useModal();
  const [rejectToggle, SetReject] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchRequets, setSearchRequets] = useState("");

  const [Loading, setLoading] = useState(false);
  const load = <span className="fa fa-spin fa-spinner"></span>;

  const { allRequest, requestTypes, next, prev, currentPage, last } =
    useSelector((state) => state.holidaysMngt);
  const dispatch = useDispatch();

  const Requests = !Array.isArray(allRequest)
    ? Object.values(allRequest)
    : allRequest;

  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
  };

  const Rejecttoggle = () => {
    SetReject(true);
  };

  const closeTogale = () => {
    SetReject(false);
  };

  const deleteRequest = (id) => {
    const request = async () => {
      const request_id = {
        request_id: id,
      };

      const res = await ApiService.delete(
        `leave-requests/delete-leave-request/${id}`,
        request_id
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        handleFetchRequest();
      }
      handleFetchRequest();
    };
    ConfirmTemplate(
      {
        title: "Delete Request",
        message: "Are You Sure You Want To Delete This Request",
      },
      request
    );
  };

  const approveRequest = (id, requested_by) => {
    const request = async () => {
      const request_id = {
        request_id: [id],
        requested_by: requested_by,
      };

      const res = await ApiService.post(
        `leave-requests/approve-leave-request/${id}`,
        request_id
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
      }
      handleFetchRequest();
    };
    ConfirmTemplate(
      {
        title: "Approve Leave Request",
        message: "Are You Sure You Want To Approve This Leave Request",
      },
      request
    );
  };

  const rejectRequest = (id, reason) => {
    const request = async () => {
      const request_id = {
        request_id: [id],
        reason_for_rejection: reason,
      };
      const res = await ApiService.post(
        `leave-requests/reject-leave-request/${id}`,
        request_id
      );
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
      }
      handleFetchRequest();
    };
    ConfirmTemplate(
      {
        title: "Reject Leave Request",
        message: "Are You Sure You Want To Reject This Leave Request",
      },
      request
    );
  };

  const handleFetchRequest = useCallback(
    async (query) => {
      setLoading(true);
      await dispatch(holidaysMngtThunk.getAllHOlidays(query));
      setLoading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    handleFetchRequest();
  }, []);

  const exportToExcel = (records) => {
    helper.printData(records, "Leave_Request_records");
  };

  const AllRequests = Requests.filter((request) => {
    return (
      (request.requested_by &&
        request.requested_by.first_name
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1) ||
      (request.leave_days &&
        request.leave_days
          .toString()
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1) ||
      (request.leave_id &&
        request.leave_id.type
          .toLowerCase()
          .indexOf(searchRequets.toLowerCase()) !== -1)
    );
  });

  let activePage = currentPage;

  return (
    <React.Fragment>
      {/* <PageBody isLoading={isLoading} message={message}> */}
      <Modal
        isOpen={rejectToggle}
        onRequestClose={closeTogale}
        style={customStyles}
        contentLabel="create-on-leave request modal"
      >
        <RejectRequestModal
          rejectRequest={rejectRequest}
          alert={alert}
          closeModal={closeTogale}
          request={rejectstate}
          requested={rejectRequested}
          approved={rejectApproved}
          getRequest={handleFetchRequest}
        />
      </Modal>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="create-on-leave request modal"
      >
        <CreateLeaveRequestModal
          alert={alert}
          requestType={requestTypes}
          getRequest={handleFetchRequest}
          closeModal={closeModal}
        />
      </Modal>
      <Modal
        isOpen={open}
        onRequestClose={closeEditModal}
        style={customStyles}
        contentLabel="create-on-leave request modal"
      >
        <EditLeaveRequestModal
          alert={alert}
          requestType={requestTypes}
          getRequest={handleFetchRequest}
          value={EditValue}
          closeModal={closeEditModal}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box-two">
                <h4 className="page-title"></h4>
                <h1 className="welcome_text">HOLIDAY MANAGEMENT</h1>
                <div className="clearfix"></div>
              </div>
            </div>
          </div>

          <div>
            <nav
              className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
              style={{
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
              }}
            >
              <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
              <ul className="navbar-nav w-100 ml-auto justify-content-center">
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/holiday"
                    style={{
                      borderRight: "3px solid #243050",
                    }}
                  >
                    EMPLOYEE LEAVE REQUEST
                  </Link>
                </li>
              </ul>
              <div
                className="navbar-collapse collapse w-100"
                id="collapsingNavbar3"
              >
                <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                  <li className="nav-item ml-auto"></li>
                </ul>
              </div>
            </nav>
          </div>

          <div className="row">
            <div className="col-lg-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <div className="table-title">
                      <div className="row">
                        <div className="col-sm-6">
                          <h2>
                            <b>EMPLOYEE LEAVE REQUEST</b>{" "}
                          </h2>
                        </div>
                        <div className="col-sm-6">
                          <button
                            onClick={openModal}
                            className="btn nt-button-color-action trigger-btn"
                            data-toggle="modal"
                          >
                            <i className="material-icons">&#xE147;</i>{" "}
                            <span>CREATE LEAVE REQUEST</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 clearfix">
                    <div
                      class="btn-group float-left"
                      role="group"
                      aria-label="Basic example"
                    >
                      {/* <button
                          type="button"
                          class="btn btn-secondary btn-group-sm"
                          onClick={() => window.print()}
                        >
                          Print
                        </button> */}
                      <button
                        type="button"
                        class="btn btn-secondary btn-group-sm"
                        onClick={() => exportToExcel(AllRequests)}
                      >
                        Export to Excel
                      </button>
                    </div>

                    <form class="form-inline my-2 my-lg-0 float-right">
                      <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        name="search"
                        value={searchRequets}
                        onChange={(e) => setSearchRequets(e.target.value)}
                      />
                    </form>
                  </div>
                  <div className="table-responsive">
                    {/* <p> No disciplinary case </p> */}

                    <table
                      id="disciplinary_table"
                      className="table table-bordered asset-table table-disciplinary-case dtMaterialDesignExample"
                    >
                      {AllRequests < 1 ? (
                        <div className="text-center m-auto">
                          <h1 className="text-dark">No record found</h1>
                        </div>
                      ) : (
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Leave Type </th>
                            <th>Employee Name</th>
                            <th>Date Requested</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Leave Days</th>
                            <th>Acted By</th>
                            <th>Acted On</th>
                            <th>Reason For Rejection</th>
                            <th>Status</th>
                            {/* {user.data.user.roles && */}
                            {/* user.data.user.roles.name === "admin" || user.data.user.id === req ? ( */}
                            <th className="notexport">
                              {Loading ? load : "Action"}
                            </th>
                            {/* ) : null} */}
                          </tr>
                        </thead>
                      )}

                      <tbody>
                        {AllRequests.map((request, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{request.leave_id.type}</td>
                            <td>
                              {capitalize(request.requested_by.first_name) +
                                " " +
                                capitalize(request.requested_by.last_name)}
                            </td>
                            <td>{moment(request.requested_on).format("ll")}</td>
                            <td>{moment(request.start_date).format("ll")}</td>
                            <td>{moment(request.end_date).format("ll")}</td>
                            <td>{request.leave_days} </td>
                            <td>
                              {request.approved_by
                                ? request.approved_by.first_name +
                                  " " +
                                  request.approved_by.last_name
                                : null}
                            </td>
                            <td>
                              {request.approved_on &&
                                moment(request.approved_on).format("ll")}
                            </td>
                            <td>
                              {request.reason_for_rejection
                                ? request.reason_for_rejection
                                : null}
                            </td>

                            <td>
                              {request.status === 1 ? (
                                <label
                                  style={{
                                    color: "orange",
                                  }}
                                >
                                  PENDING
                                </label>
                              ) : null}
                              {request.status === 2 ? (
                                <label
                                  style={{
                                    color: "green",
                                  }}
                                >
                                  APPROVED
                                </label>
                              ) : null}

                              {request.status === 3 ? (
                                <label
                                  style={{
                                    color: "darkred",
                                  }}
                                >
                                  REJECTED
                                </label>
                              ) : null}
                            </td>

                            {/* {request.requested_by.id !== user.data.user.id ? ( */}
                            <td>
                              <div className="dropdown">
                                <a
                                  href="#"
                                  className={`dropdown-toggle card-drop arrow-none ${
                                    request.status === 2 || request.status === 3
                                      ? "disabled d-none"
                                      : ""
                                  }`}
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <h3 className="m-0 text-muted">
                                    <i className="fa fa-ellipsis-v"></i>
                                    {/* <span className="fa fa-spin fa-spinner request_spinner"></span> */}
                                  </h3>
                                </a>
                                <div
                                  className="dropdown-menu dropdown-menu-right"
                                  aria-labelledby="btnGroupDrop1"
                                >
                                  {(user.data.user.roles &&
                                    user.data.user.roles.name ===
                                      "line manager") ||
                                  (user.data.user.roles.name === "admin" &&
                                    user.data.user &&
                                    user.data.user.id !==
                                      request.requested_by.id) ? (
                                    <div>
                                      {request.status === 1 ? (
                                        <a
                                          className="dropdown-item"
                                          onClick={() => {
                                            approveRequest(
                                              request.id,
                                              request.requested_by.id
                                            );
                                          }}
                                          id="approve_leave_request_btn"
                                        >
                                          Approve
                                        </a>
                                      ) : null}
                                      {request.status === 1 ? (
                                        <a
                                          className="dropdown-item"
                                          onClick={() => {
                                            console.log("req", request);
                                            SetRejectRequested(
                                              request.requested_by.id
                                            );
                                            SetRejectApproved(
                                              request.approved_by !== null
                                                ? request.approved_by.id
                                                : ""
                                            );
                                            SetRejectState(request.id);
                                            Rejecttoggle();
                                          }}
                                          id="reject_leave_request_btn"
                                        >
                                          Reject
                                        </a>
                                      ) : null}
                                    </div>
                                  ) : null}

                                  {user.data.user &&
                                  user.data.user.id ===
                                    request.requested_by.id ? (
                                    <div>
                                      <a
                                        className="dropdown-item"
                                        onClick={() => {
                                          const value = {
                                            id: request.id,
                                            request_type: request.leave_id.id,
                                            start_date: request.start_date,
                                            end_date: request.end_date,
                                          };
                                          setEditValue(value);
                                          openEditModal();
                                        }}
                                        id="edit_leave_request_btn"
                                      >
                                        Edit
                                      </a>

                                      <a
                                        className="dropdown-item"
                                        onClick={() => {
                                          deleteRequest(request.id);
                                        }}
                                        id="delete_leave_request_btn"
                                      >
                                        Delete
                                      </a>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <nav aria-label="...">
                      <ul class="pagination">
                        <li
                          class={`page-item ${prev === null ? "disabled" : ""}`}
                        >
                          <a
                            class="page-link"
                            onClick={() => handleFetchRequest(prev)}
                            aria-disabled={
                              !allRequest.prev_page_url ? "true" : "false"
                            }
                            // aria-disabled={activityLog.prev_page_url}
                          >
                            Previous
                          </a>
                        </li>
                        {[...Array(last).keys()].map((page, i) => (
                          <li
                            class={`page-item ${
                              page + 1 === activePage ? "active" : ""
                            }`}
                            key={i}
                          >
                            <a
                              class="page-link"
                              id={page + 1}
                              onClick={() =>
                                handleFetchRequest(`?page=${page + 1}`)
                              }
                            >
                              {page + 1}
                            </a>
                          </li>
                        ))}
                        <li
                          class={`page-item ${next === null ? "disabled" : ""}`}
                        >
                          <a
                            class="page-link"
                            onClick={() => handleFetchRequest(next)}
                          >
                            {Loading ? load : "Next"}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </PageBody> */}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/holidaymanagement/index.js